// @ is an alias to /src
import Home from '@/components/Home.vue';
export default {
  name: 'HomeView',
  components: {
    Home
  },
  data() {
    return {
      url: "/bg/bg1.jpg"
    };
  }
};